import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context";
import lowOccupancyImg from "../../assets/images/occupancy/low_occupancy.png";
import mediumOccupancyImg from "../../assets/images/occupancy/medium_occupancy.png";
import highOccupancyImg from "../../assets/images/occupancy/high_occupancy.png";
import elevatedOccupancyImg from "../../assets/images/occupancy/elevated_occupancy.png";

const getVillageOccupancy = async (villageSlug) => {
  // call API to get village occupancy
  switch (villageSlug) {
    case "almeida":
      return 0;
    case "belmonte":
      return 1;
    case "castelo-mendo":
      return 2;
    case "castelo-rodrigo":
      return 1;
    case "trancoso":
      return 3;
    default:
      return 0;
  }
};

const pickImage = (occupancy) => {
  switch (occupancy) {
    case 0:
      return lowOccupancyImg;
    case 1:
      return mediumOccupancyImg;
    case 2:
      return highOccupancyImg;
    case 3:
      return elevatedOccupancyImg;
    default:
      return lowOccupancyImg;
  }
};

function VillageOccupancy({ location }) {
  const [occupancy, setOccupancy] = useState(0);
  const info = useContext(AppContext);

  useEffect(() => {
    const villageSlug = location.pathname.split("/")[2];
    (async () => setOccupancy(await getVillageOccupancy(villageSlug)))();
  }, []);

  return (
    <div style={{ textAlign: "center" }}>
      {/* <div>{info.t("occupancy")}</div> */}
      <div style={{ margin: "10px 20px", textTransform: "uppercase" }}>
        <strong>Nível de ocupação atual da Aldeia</strong>
      </div>
      <img
        src={pickImage(occupancy)}
        alt="occupancy"
        width={300}
        style={{ marginBottom: 20 }}
      />
    </div>
  );
}

export default VillageOccupancy;
